import { createRequest } from "helpers/tools";

export const sendFBInfosToServisAsync = async (data) => {
    return await createRequest({
        suffix: `lead/facebook/get-pages`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
